import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, Check, ClipboardList } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";

// Personality: Bespoke, considered — soft cream, checklist motif, calm sage accents.
const PlanLanding = () => {
  const items = [
    "Symptom priorities, chosen by you",
    "Nutrition and movement that fits your week",
    "Sleep, mood and stress rituals worth trying",
    "Questions to bring to your next appointment",
  ];
  return (
    <div className="min-h-screen bg-[hsl(35,40%,96%)]">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <section className="container mx-auto px-6 pt-16 pb-24 max-w-4xl">
        <span className="text-xs uppercase tracking-[0.3em] text-primary">Your Personal Plan</span>
        <h1 className="mt-6 text-5xl md:text-7xl leading-[1.05]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
          Not a program. A plan made <em className="italic">for you</em>.
        </h1>
        <p className="mt-8 text-lg text-foreground/70 leading-relaxed max-w-2xl">
          Built from what you've shared, refined as you learn what works. A short, honest set of next
          steps — never a hundred-item list you'll abandon by Friday.
        </p>
      </section>

      <section className="container mx-auto px-6 pb-24">
        <div className="max-w-2xl mx-auto bg-background rounded-3xl p-10 md:p-14 border border-primary/20 shadow-elegant">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-6">This week</p>
          <ul className="space-y-5">
            {items.map((i) => (
              <li key={i} className="flex items-start gap-4">
                <span className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <Check className="h-3.5 w-3.5 text-primary" />
                </span>
                <span className="text-lg text-foreground/80" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{i}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24 text-center">
        <Button asChild size="lg" className="px-10 py-6 text-lg">
          <Link to="/plan"><ClipboardList className="mr-2 h-5 w-5" /> Open your plan <ArrowRight className="ml-2 h-5 w-5" /></Link>
        </Button>
      </section>

      <Footer />
    </div>
  );
};
export default PlanLanding;
